import { ITableListLegend, TActionButton } from 'src/app/interfaces/components/table.interface';
import { IContentAreaActionClick, TContentAreaAction } from 'src/app/interfaces/components/content-area.interface';
import { ISelectOption } from 'src/app/interfaces/components/select.interface';

export const contentAreaActions: IContentAreaActionClick<TContentAreaAction>[] = [
  { type: 'export', label: 'CONTENT_AREA.EXPORT_EXCEL' },
  { type: 'add', label: 'CLIENTS_LIST.ADD_BUTTON' },
];

export const searchOptions: ISelectOption[] = [
  { value: 'name', label: 'CLIENTS_LIST.FILTERS.SEARCH_SELECT.NAME' },
  { value: 'document', label: 'CLIENTS_LIST.FILTERS.SEARCH_SELECT.DOCUMENT' },
  { value: 'position', label: 'CLIENTS_LIST.FILTERS.SEARCH_SELECT.POSITION' },
];

export const tableLegends: ITableListLegend[] = [
  { name: 'CLIENTS_LIST.TABLE.DOCUMENT', value: 'document', type: 'document' },
  { name: 'CLIENTS_LIST.TABLE.SOCIAL_REASON', value: 'name' },
  { name: 'CLIENTS_LIST.TABLE.TYPE', value: 'isHeadOffice' },
  { name: 'CLIENTS_LIST.TABLE.STATUS', value: 'tableStatus' },
];

export const displayedColumns = [
  'document',
  'name',
  'isHeadOffice',
  'tableStatus',
];

export const tableActions: TActionButton[] = [
  'view',
  'edit',
  'delete',
  'toggle',
];

export const personTypeOptions: ISelectOption[] = [
  { value: 'true', label: 'CLIENTS_LIST.FILTERS.PERSON_TYPE.OPTIONS.MATRIZ' },
  { value: 'false', label: 'CLIENTS_LIST.FILTERS.PERSON_TYPE.OPTIONS.BRANCH' },
];
